import { Box, Divider, Link, Stack } from '@mui/material';
import useLocales from '@hooks/useLocales';
import { styles } from './styles';

export default function NavbarDocs() {
  const { t } = useLocales();

  return (
    <Stack sx={{ px: 4, width: 1, textAlign: 'center', display: 'block' }}>
      {/* TODO: Uncomment following code after setting correct PATH_DOCS var */}
      {/* <div>
        <Typography variant="body2" sx={{ color: theme.palette.common.white }}>
          {t('navbar.questions')}
        </Typography>
      </div>

      <SButton
        href={PATH_DOCS}
        // ! Temporary for build purposes
        // target="_blank"
        // rel="noopener"
        variant="contained"
      >
        {t('navbar.help')}
      </SButton> */}
      <Box sx={styles.infoLinks}>
        <Link href="https://www.bigpurpledot.com/privacy" sx={styles.link}>
          {t('navbar.privacy_policy')}
        </Link>
        <Divider orientation="vertical" sx={styles.divider} />
        <Link href="https://www.bigpurpledot.com/terms" sx={styles.link}>
          {t('navbar.terms_of_use')}
        </Link>
      </Box>
    </Stack>
  );
}
